// TODO: Remove these when backend does pre-filtering
// Only these accounts accept pushing of items
export const QBO_ACCOUNT_TYPES_ALLOWING_ITEM_PUSH = ['INCOME']
